import { __assign } from "tslib";
import { testDataCreator } from '@wix/answers-lib';
var timeZone = 'UTC';
export var createTicketsSlaAnalyticsFilterDto = testDataCreator({
    startDate: '1988-31-10',
    endDate: '1988-31-10',
    timeZone: timeZone
});
export var createGetTicketsSlaOverviewDto = testDataCreator(function () { return (__assign({ metrics: [] }, createTicketsSlaAnalyticsFilterDto())); });
export var createTicketsOverviewStats = testDataCreator(function () { return ({}); });
export var createTicketsverviewStatsComparison = testDataCreator(function () { return ({
    value: createTicketsOverviewStats(),
    compared: createTicketsOverviewStats()
}); });
//# sourceMappingURL=builders.js.map